import filtersApi from '@/api/v1/filters';

export default {
  namespaced: true,

  state: {
    filtersOptions: {
      projectTypes: [],
      media: [],
      departments: [],
      projectStatuses: [],
      campaigns: [],
      users: [],
      projectMembers: [],
      projectManagers: [],
      projectOrderers: [],
      visualNumberRequestsPurposes: [],
      projectStatusesForEdit: [],
      projectChangeTypes: [],
      projectPriorities: [],
    },
    selectedFilters: {},
    order: 'created_at_descending',
  },

  mutations: {
    SET_FILTERS_OPTIONS(state, filters) {
      state.filtersOptions = filters;
    },

    SET_SELECTED_FILTERS(state, filters) {
      state.selectedFilters = {
        ...state.selectedFilters,
        ...filters,
      };
    },

    REMOVE_SELECTED_FILTERS(state, selectedFiltersState) {
      state.selectedFilters = selectedFiltersState;
    },

    SET_ITEMS_ORDER(state, sortBy) {
      state.order = sortBy;
    },
  },

  actions: {
    fetchFiltersOptions({ commit }) {
      filtersApi.index().then((response) => {
        commit('SET_FILTERS_OPTIONS', response.data);
      });
    },

    setFilters({ commit, dispatch }, filters) {
      return new Promise((resolve) => {
        commit('SET_SELECTED_FILTERS', filters);
        dispatch('pagination/setPage', 1, { root: true });
        resolve();
      });
    },

    clearFilters({ commit }, baseFilter) {
      let clearedFilters = {};
      if (baseFilter) clearedFilters = baseFilter;

      return new Promise((resolve) => {
        commit('REMOVE_SELECTED_FILTERS', clearedFilters);
        resolve();
      });
    },

    setSorting({ commit }, sortBy) {
      let sortOrder = 'created_at_descending';
      if (sortBy) sortOrder = sortBy;

      return new Promise((resolve) => {
        commit('SET_ITEMS_ORDER', sortOrder);
        resolve();
      });
    },
  },

  getters: {
    sortedOptions:
      (state) =>
      (filterOptionsLabel, filterLabel = filterOptionsLabel) => {
        if (!filterOptionsLabel) return [];
        const options = state.selectedFilters[filterLabel];

        return state?.filtersOptions?.[filterOptionsLabel]?.sort(
          (a, b) => options?.includes(b.id) - options?.includes(a.id),
        );
      },
  },
};
